module.exports = __webpack_public_path__ + "img/icon-auth-primary.29f77adc.svg";